import PropTypes from "prop-types";
import React from "react";

import { classNames } from "@swa-ui/string";

import styles from "./Width.module.scss";

/**
 * Width provides a consistent way to size content.
 */
export const Width = (props) => {
  const { children, className, id, width } = props;

  return <div {...getProps()}>{children}</div>;

  function getProps() {
    return {
      className: getClass(),
      id,
    };
  }

  function getClass() {
    return classNames(
      styles.width,
      {
        [styles.large]: width === "large",
        [styles.medium]: width === "medium",
        [styles.small]: width === "small",
        [styles.xLarge]: width === "xlarge",
        [styles.xSmall]: width === "xsmall",
      },
      className
    );
  }
};

Width.displayName = "Width";
export const widthPropTypes = {
  /** Content that will be rendered in an appropriately sized container. */
  children: PropTypes.node,

  /** Additional classes for positioning the component. */
  className: PropTypes.string,

  /**
   * id can be useful when another DOM element "controls" the concealed/revealed state. The
   * controlling element should use aria-control to reflect this correlation.
   */
  id: PropTypes.string,

  /** Width of content container. */
  width: PropTypes.oneOf(["large", "medium", "small", "xlarge", "xsmall"]),
};

Width.propTypes = widthPropTypes;
